import client from "../client";

interface Request {
  transaction_id?: string;
}

export default function API(request: Request): Promise<any> {
  const recordID = Number(request.transaction_id ?? 0);
  return client
    .post(`return_to_loss_v2/claim`, {
      record_id: recordID,
    })
    .then((response) => response.data);
}
